module.exports = __webpack_public_path__ + "static/sedona.98436bd2.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/sedona.png
// module id = 449
// module chunks = 168707334958949